/**
 * blockFaceGroups.js
 * Manuelles Mapping von Multi-Face-Bloecken.
 *
 * Face-Reihenfolge bei THREE.BoxGeometry:
 *   faceIndex / 2:  0=right(+x), 1=left(-x), 2=top(+y), 3=bottom(-y), 4=front(+z), 5=back(-z)
 *
 * Gruppen-Format:
 *   {
 *     label: 'Anzeigename',
 *     faces: {
 *       all?:    'block/X.png',   // alle 6 Seiten gleich
 *       sides?:  'block/X.png',   // right, left, front, back
 *       top?:    'block/X.png',
 *       bottom?: 'block/X.png',
 *       front?:  'block/X.png',
 *       back?:   'block/X.png',
 *       right?:  'block/X.png',
 *       left?:   'block/X.png',
 *     }
 *   }
 *
 * Fehlende Faces erben von 'sides', dann von 'all'.
 * Der Key im BLOCK_FACE_GROUPS-Objekt ist der "Basis-Name" des Blocks.
 */

// Basis-Pfad-Prefix
const B = 'block/';

const BLOCK_FACE_GROUPS = {
  // ── Holz-Staemme (Log) ───────────────────────────────────────────
  oak_log:             { label: 'Eichenstamm',           faces: { sides: B+'oak_log.png',             top: B+'oak_log_top.png',             bottom: B+'oak_log_top.png' } },
  birch_log:           { label: 'Birkenstamm',           faces: { sides: B+'birch_log.png',           top: B+'birch_log_top.png',           bottom: B+'birch_log_top.png' } },
  spruce_log:          { label: 'Fichtenstamm',          faces: { sides: B+'spruce_log.png',          top: B+'spruce_log_top.png',          bottom: B+'spruce_log_top.png' } },
  dark_oak_log:        { label: 'Dunkler Eichenstamm',   faces: { sides: B+'dark_oak_log.png',        top: B+'dark_oak_log_top.png',        bottom: B+'dark_oak_log_top.png' } },
  acacia_log:          { label: 'Akazienstamm',          faces: { sides: B+'acacia_log.png',          top: B+'acacia_log_top.png',          bottom: B+'acacia_log_top.png' } },
  jungle_log:          { label: 'Dschungelstamm',        faces: { sides: B+'jungle_log.png',          top: B+'jungle_log_top.png',          bottom: B+'jungle_log_top.png' } },
  cherry_log:          { label: 'Kirschstamm',           faces: { sides: B+'cherry_log.png',          top: B+'cherry_log_top.png',          bottom: B+'cherry_log_top.png' } },
  mangrove_log:        { label: 'Mangrovenstaemm',        faces: { sides: B+'mangrove_log.png',        top: B+'mangrove_log_top.png',        bottom: B+'mangrove_log_top.png' } },
  bamboo_block:        { label: 'Bambusblock',           faces: { sides: B+'bamboo_block.png',        top: B+'bamboo_block_top.png',        bottom: B+'bamboo_block_top.png' } },
  crimson_stem:        { label: 'Karmesinschaft',        faces: { sides: B+'crimson_stem.png',        top: B+'crimson_stem_top.png',        bottom: B+'crimson_stem_top.png' } },
  warped_stem:         { label: 'Verworfener Schaft',    faces: { sides: B+'warped_stem.png',         top: B+'warped_stem_top.png',         bottom: B+'warped_stem_top.png' } },
  // Geschaelte Staemme
  stripped_oak_log:    { label: 'Geschaelter Eichenstamm',      faces: { sides: B+'stripped_oak_log.png',    top: B+'stripped_oak_log_top.png',    bottom: B+'stripped_oak_log_top.png' } },
  stripped_birch_log:  { label: 'Geschaelter Birkenstamm',      faces: { sides: B+'stripped_birch_log.png',  top: B+'stripped_birch_log_top.png',  bottom: B+'stripped_birch_log_top.png' } },
  stripped_spruce_log: { label: 'Geschaelter Fichtenstamm',     faces: { sides: B+'stripped_spruce_log.png', top: B+'stripped_spruce_log_top.png', bottom: B+'stripped_spruce_log_top.png' } },
  stripped_dark_oak_log:{ label: 'Geschaelter Dunkler Eichenstamm', faces: { sides: B+'stripped_dark_oak_log.png', top: B+'stripped_dark_oak_log_top.png', bottom: B+'stripped_dark_oak_log_top.png' } },
  stripped_acacia_log: { label: 'Geschaelter Akazienstamm',     faces: { sides: B+'stripped_acacia_log.png', top: B+'stripped_acacia_log_top.png', bottom: B+'stripped_acacia_log_top.png' } },
  stripped_jungle_log: { label: 'Geschaelter Dschungelstamm',   faces: { sides: B+'stripped_jungle_log.png', top: B+'stripped_jungle_log_top.png', bottom: B+'stripped_jungle_log_top.png' } },
  stripped_cherry_log: { label: 'Geschaelter Kirschstamm',      faces: { sides: B+'stripped_cherry_log.png', top: B+'stripped_cherry_log_top.png', bottom: B+'stripped_cherry_log_top.png' } },
  stripped_mangrove_log:{ label: 'Geschaelter Mangrovenstaemm',  faces: { sides: B+'stripped_mangrove_log.png', top: B+'stripped_mangrove_log_top.png', bottom: B+'stripped_mangrove_log_top.png' } },
  stripped_bamboo_block:{ label: 'Geschaelter Bambusblock',      faces: { sides: B+'stripped_bamboo_block.png', top: B+'stripped_bamboo_block_top.png', bottom: B+'stripped_bamboo_block_top.png' } },
  stripped_crimson_stem:{ label: 'Geschaelter Karmesinschaft',   faces: { sides: B+'stripped_crimson_stem.png', top: B+'stripped_crimson_stem_top.png', bottom: B+'stripped_crimson_stem_top.png' } },
  stripped_warped_stem: { label: 'Geschaelter Verworfener Schaft', faces: { sides: B+'stripped_warped_stem.png', top: B+'stripped_warped_stem_top.png', bottom: B+'stripped_warped_stem_top.png' } },

  // ── Saeulenartige Bloecke ─────────────────────────────────────────
  quartz_pillar:    { label: 'Quarzsaeule',        faces: { sides: B+'quartz_pillar.png',    top: B+'quartz_pillar_top.png',    bottom: B+'quartz_pillar_top.png' } },
  purpur_pillar:    { label: 'Purpursaeule',        faces: { sides: B+'purpur_pillar.png',    top: B+'purpur_pillar_top.png',    bottom: B+'purpur_pillar_top.png' } },
  basalt:           { label: 'Basalt',              faces: { sides: B+'basalt_side.png',      top: B+'basalt_top.png',           bottom: B+'basalt_top.png' } },
  polished_basalt:  { label: 'Polierter Basalt',    faces: { sides: B+'polished_basalt_side.png', top: B+'polished_basalt_top.png', bottom: B+'polished_basalt_top.png' } },
  bone_block:       { label: 'Knochenblock',        faces: { sides: B+'bone_block_side.png',  top: B+'bone_block_top.png',       bottom: B+'bone_block_top.png' } },
  hay_block:        { label: 'Heublock',            faces: { sides: B+'hay_block_side.png',   top: B+'hay_block_top.png',        bottom: B+'hay_block_top.png' } },
  ancient_debris:   { label: 'Alter Trümmer',       faces: { sides: B+'ancient_debris_side.png', top: B+'ancient_debris_top.png', bottom: B+'ancient_debris_top.png' } },

  // ── Quarz ────────────────────────────────────────────────────────
  quartz_block:     { label: 'Quarzblock',          faces: { sides: B+'quartz_block_side.png', top: B+'quartz_block_top.png', bottom: B+'quartz_block_bottom.png' } },

  // ── Sandstein ─────────────────────────────────────────────────────
  sandstone:        { label: 'Sandstein',           faces: { sides: B+'sandstone.png',         top: B+'sandstone_top.png',        bottom: B+'sandstone_bottom.png' } },
  red_sandstone:    { label: 'Roter Sandstein',     faces: { sides: B+'red_sandstone.png',     top: B+'red_sandstone_top.png',    bottom: B+'red_sandstone_bottom.png' } },

  // ── Erdoberflaeche ────────────────────────────────────────────────
  grass_block:      { label: 'Grasblock',           faces: { sides: B+'grass_block_side.png',  top: B+'grass_block_top.png',      bottom: B+'dirt.png' } },
  mycelium:         { label: 'Myzel',               faces: { sides: B+'mycelium_side.png',     top: B+'mycelium_top.png',         bottom: B+'dirt.png' } },
  podzol:           { label: 'Podsol',              faces: { sides: B+'podzol_side.png',       top: B+'podzol_top.png',           bottom: B+'dirt.png' } },
  dirt_path:        { label: 'Trampelpfad',         faces: { sides: B+'dirt_path_side.png',    top: B+'dirt_path_top.png',        bottom: B+'dirt.png' } },
  crimson_nylium:   { label: 'Karmesin-Nylium',     faces: { sides: B+'crimson_nylium_side.png', top: B+'crimson_nylium.png',     bottom: B+'netherrack.png' } },
  warped_nylium:    { label: 'Verworfenes Nylium',  faces: { sides: B+'warped_nylium_side.png',  top: B+'warped_nylium.png',       bottom: B+'netherrack.png' } },

  // ── TNT + einfache Seite/Oben/Unten ──────────────────────────────
  tnt:              { label: 'TNT',                 faces: { sides: B+'tnt_side.png',          top: B+'tnt_top.png',              bottom: B+'tnt_bottom.png' } },
  barrel:           { label: 'Fass',                faces: { sides: B+'barrel_side.png',       top: B+'barrel_top.png',           bottom: B+'barrel_bottom.png' } },
  cactus:           { label: 'Kaktus',              faces: { sides: B+'cactus_side.png',       top: B+'cactus_top.png',           bottom: B+'cactus_bottom.png' } },
  composter:        { label: 'Komposter',           faces: { sides: B+'composter_side.png',    top: B+'composter_top.png',        bottom: B+'composter_bottom.png' } },
  jukebox:          { label: 'Jukebox',             faces: { sides: B+'jukebox_side.png',      top: B+'jukebox_top.png',          bottom: B+'jukebox_side.png' } },
  piston:           { label: 'Kolben',              faces: { sides: B+'piston_side.png',       top: B+'piston_top.png',           bottom: B+'piston_bottom.png' } },
  target:           { label: 'Zielscheibe',         faces: { sides: B+'target_side.png',       top: B+'target_top.png',           bottom: B+'target_top.png' } },
  lodestone:        { label: 'Magnetstein',         faces: { sides: B+'lodestone_side.png',    top: B+'lodestone_top.png',        bottom: B+'lodestone_side.png' } },
  melon:            { label: 'Melone',              faces: { sides: B+'melon_side.png',        top: B+'melon_top.png',            bottom: B+'melon_top.png' } },
  pumpkin:          { label: 'Kürbis',              faces: { sides: B+'pumpkin_side.png',      top: B+'pumpkin_top.png',          bottom: B+'pumpkin_top.png' } },
  deepslate:        { label: 'Tiefer Schiefer',     faces: { sides: B+'deepslate.png',         top: B+'deepslate_top.png',        bottom: B+'deepslate_top.png' } },
  sculk_sensor:     { label: 'Sculk-Sensor',        faces: { sides: B+'sculk_sensor_side.png', top: B+'sculk_sensor_top.png',    bottom: B+'sculk_sensor_bottom.png' } },
  sculk_catalyst:   { label: 'Sculk-Katalysator',   faces: { sides: B+'sculk_catalyst_side.png', top: B+'sculk_catalyst_top.png', bottom: B+'sculk_catalyst_bottom.png' } },
  stonecutter:      { label: 'Steinsäge',           faces: { sides: B+'stonecutter_side.png',  top: B+'stonecutter_top.png',      bottom: B+'stonecutter_bottom.png' } },
  enchanting_table: { label: 'Verzauberungstisch',  faces: { sides: B+'enchanting_table_side.png', top: B+'enchanting_table_top.png', bottom: B+'enchanting_table_bottom.png' } },

  // ── Öfen / Schmelzöfen (Front + Seite + Oben) ────────────────────
  furnace:          { label: 'Ofen',                faces: { sides: B+'furnace_side.png', front: B+'furnace_front.png', back: B+'furnace_side.png', top: B+'furnace_top.png', bottom: B+'furnace_top.png' } },
  blast_furnace:    { label: 'Hochofen',            faces: { sides: B+'blast_furnace_side.png', front: B+'blast_furnace_front.png', back: B+'blast_furnace_side.png', top: B+'blast_furnace_top.png', bottom: B+'blast_furnace_top.png' } },
  smoker:           { label: 'Räucherofen',         faces: { sides: B+'smoker_side.png', front: B+'smoker_front.png', back: B+'smoker_side.png', top: B+'smoker_top.png', bottom: B+'smoker_bottom.png' } },

  // ── Werkstationen ────────────────────────────────────────────────
  crafting_table:   { label: 'Werkzeugbank',        faces: { sides: B+'crafting_table_side.png', front: B+'crafting_table_front.png', back: B+'crafting_table_side.png', top: B+'crafting_table_top.png', bottom: B+'oak_planks.png' } },
  loom:             { label: 'Webstuhl',            faces: { sides: B+'loom_side.png', front: B+'loom_front.png', back: B+'loom_side.png', top: B+'loom_top.png', bottom: B+'loom_bottom.png' } },
  fletching_table:  { label: 'Befiederungstisch',   faces: { sides: B+'fletching_table_side.png', front: B+'fletching_table_front.png', back: B+'fletching_table_side.png', top: B+'fletching_table_top.png', bottom: B+'birch_planks.png' } },
  smithing_table:   { label: 'Schmiedetisch',       faces: { sides: B+'smithing_table_side.png', front: B+'smithing_table_front.png', back: B+'smithing_table_side.png', top: B+'smithing_table_top.png', bottom: B+'smithing_table_bottom.png' } },

  // ── Bienennest / Bienenstock ──────────────────────────────────────
  bee_nest:         { label: 'Bienennest',          faces: { sides: B+'bee_nest_side.png', front: B+'bee_nest_front.png', back: B+'bee_nest_side.png', top: B+'bee_nest_top.png', bottom: B+'bee_nest_bottom.png' } },
  beehive:          { label: 'Bienenstock',         faces: { sides: B+'beehive_side.png',  front: B+'beehive_front.png',  back: B+'beehive_side.png',  top: B+'beehive_end.png',  bottom: B+'beehive_end.png' } },

  // ── Beobachter / Spender / Dropper ───────────────────────────────
  observer:         { label: 'Beobachter',          faces: { sides: B+'observer_side.png', front: B+'observer_front.png', back: B+'observer_back.png', top: B+'observer_top.png', bottom: B+'observer_top.png' } },
  dispenser:        { label: 'Spender',             faces: { sides: B+'furnace_side.png',  front: B+'dispenser_front.png', back: B+'furnace_side.png', top: B+'furnace_top.png', bottom: B+'furnace_top.png' } },
  dropper:          { label: 'Werfer',              faces: { sides: B+'furnace_side.png',  front: B+'dropper_front.png',   back: B+'furnace_side.png', top: B+'furnace_top.png', bottom: B+'furnace_top.png' } },

  // ── Weitere Bloecke ───────────────────────────────────────────────
  daylight_detector:       { label: 'Tageslichtsensor',  faces: { sides: B+'daylight_detector_side.png', top: B+'daylight_detector_top.png', bottom: B+'daylight_detector_side.png' } },
  dried_kelp:              { label: 'Getrockneter Seetang', faces: { sides: B+'dried_kelp_side.png', top: B+'dried_kelp_top.png', bottom: B+'dried_kelp_bottom.png' } },
  end_portal_frame:        { label: 'Endportalrahmen',   faces: { sides: B+'end_portal_frame_side.png', top: B+'end_portal_frame_top.png', bottom: B+'end_stone.png' } },
  sniffer_egg_not_cracked: { label: 'Sniffer-Ei',        faces: { sides: B+'sniffer_egg_not_cracked_side.png', top: B+'sniffer_egg_not_cracked_top.png', bottom: B+'sniffer_egg_not_cracked_top.png' } },
  respawn_anchor:          { label: 'Wiedergeburtspunkt', faces: { sides: B+'respawn_anchor_side1.png', top: B+'respawn_anchor_top.png', bottom: B+'respawn_anchor_bottom.png' } },
};

// ── Hilfsfunktionen ───────────────────────────────────────────────────────

/**
 * Baut ein "assetPath -> groupKey" Reverse-Lookup-Map.
 * Jeder assetPath der in irgendeiner Gruppe vorkommt zeigt auf den groupKey.
 */
let _reverseLookup = null;
function getReverseMap() {
  if (_reverseLookup) return _reverseLookup;
  _reverseLookup = new Map();
  for (const [groupKey, group] of Object.entries(BLOCK_FACE_GROUPS)) {
    for (const assetPath of Object.values(group.faces)) {
      if (!_reverseLookup.has(assetPath)) {
        _reverseLookup.set(assetPath, groupKey);
      }
    }
  }
  return _reverseLookup;
}

/**
 * Gibt die Gruppen-Definition zurueck wenn assetPath Teil einer Gruppe ist, sonst null.
 * @param {string} assetPath z.B. "block/oak_log_top.png"
 * @returns {{ groupKey, label, faces } | null}
 */
export function getBlockGroup(assetPath) {
  const map = getReverseMap();
  const groupKey = map.get(assetPath);
  if (!groupKey) return null;
  const group = BLOCK_FACE_GROUPS[groupKey];
  return { groupKey, label: group.label, faces: group.faces };
}

/**
 * Konvertiert die logische Faces-Definition ({ sides, top, bottom, front, back })
 * in ein vollstaendiges 6-Face-Objekt { right, left, top, bottom, front, back }.
 * THREE.BoxGeometry face order: +x=right, -x=left, +y=top, -y=bottom, +z=front, -z=back
 */
export function resolveToSixFaces(faceDef) {
  const fallback = faceDef.all || faceDef.sides || Object.values(faceDef)[0];
  return {
    right:  faceDef.right  || faceDef.sides || fallback,
    left:   faceDef.left   || faceDef.sides || fallback,
    top:    faceDef.top    || fallback,
    bottom: faceDef.bottom || faceDef.top   || fallback,
    front:  faceDef.front  || faceDef.sides || fallback,
    back:   faceDef.back   || faceDef.sides || fallback,
  };
}

/**
 * Gibt alle einzigartigen assetPaths einer Gruppe zurueck.
 * @param {string} assetPath beliebiger Pfad aus der Gruppe
 * @returns {Set<string>} alle assetPaths der Gruppe
 */
export function getGroupMembers(assetPath) {
  const group = getBlockGroup(assetPath);
  if (!group) return new Set([assetPath]);
  return new Set(Object.values(group.faces));
}

/**
 * Gibt true zurueck wenn assetPath Teil einer Gruppe ist.
 */
export function isGroupMember(assetPath) {
  return getReverseMap().has(assetPath);
}

/**
 * Gibt alle Gruppen-Keys zurueck die eine bestimmte assetPath als "Haupt-Textur" haben.
 * Haupt-Textur = erster eindeutiger Wert in der faces-Definition.
 */
export function getMainTextureForGroup(groupKey) {
  const group = BLOCK_FACE_GROUPS[groupKey];
  if (!group) return null;
  // Die "Seiten"-Textur ist die Hauptdarstellung
  return group.faces.sides || group.faces.all || Object.values(group.faces)[0];
}

/**
 * Gibt ein Array aller "einzigartigen Textur-Slots" einer Gruppe zurueck.
 * Jeder Slot hat einen Label und den assetPath.
 * Doppelte werden zusammengefasst (z.B. sides-Textur fuer 4 Faces = ein Slot).
 *
 * @param {object} faceDef - group.faces
 * @returns {Array<{ label, assetPath, faceKeys }>}
 */
export function getUniqueTextureSlots(faceDef) {
  const sixFaces = resolveToSixFaces(faceDef);
  // Gruppieren: assetPath -> welche faceKeys nutzen sie
  const pathToFaces = {};
  for (const [faceKey, path] of Object.entries(sixFaces)) {
    if (!pathToFaces[path]) pathToFaces[path] = { assetPath: path, faceKeys: [] };
    pathToFaces[path].faceKeys.push(faceKey);
  }
  // Label bestimmen
  const FACE_LABELS = {
    right: 'Rechts', left: 'Links', top: 'Oben',
    bottom: 'Unten', front: 'Vorne', back: 'Hinten',
  };
  const COMBINED_LABELS = {
    'right,left,front,back': 'Seiten',
    'right,left,top,bottom,front,back': 'Alle Seiten',
    'top,bottom': 'Oben & Unten',
    'right,left': 'Links & Rechts',
    'front,back': 'Vorne & Hinten',
  };
  return Object.values(pathToFaces).map(({ assetPath, faceKeys }) => {
    const sorted = [...faceKeys].sort((a, b) => ['right','left','top','bottom','front','back'].indexOf(a) - ['right','left','top','bottom','front','back'].indexOf(b));
    const comboKey = sorted.join(',');
    const label = COMBINED_LABELS[comboKey] || sorted.map(k => FACE_LABELS[k]).join(' & ');
    return { label, assetPath, faceKeys: sorted };
  }).sort((a, b) => {
    // Seiten zuerst, dann Oben, dann Unten
    const order = ['Seiten', 'Vorne', 'Hinten', 'Oben & Unten', 'Oben', 'Unten', 'Links & Rechts'];
    const ai = order.indexOf(a.label);
    const bi = order.indexOf(b.label);
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });
}

export { BLOCK_FACE_GROUPS };
